export default () => ({
  alls: [],
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/forall/resources/data.js